import { c as _c } from "react/compiler-runtime";
import type { RiskSignalGroupKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useRiskSignalGroupText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings.riskSignals.group"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = group => {
      if (group === "kyc") {
        return t(_temp);
      }
      if (group === "kyb") {
        return t(_temp2);
      }
      if (group === "doc") {
        return t(_temp3);
      }
      if (group === "web_device") {
        return t(_temp4);
      }
      if (group === "native_device") {
        return t(_temp5);
      }
      if (group === "aml") {
        return t(_temp6);
      }
      if (group === "behavior") {
        return t(_temp7);
      }
      if (group === "phone") {
        return t(_temp8);
      }
      if (group === "synthetic") {
        return t(_temp9);
      }
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useRiskSignalGroupText;
function _temp($) {
  return $.kyc;
}
function _temp2($_0) {
  return $_0.kyb;
}
function _temp3($_1) {
  return $_1.doc;
}
function _temp4($_2) {
  return $_2.webDevice;
}
function _temp5($_3) {
  return $_3.nativeDevice;
}
function _temp6($_4) {
  return $_4.aml;
}
function _temp7($_5) {
  return $_5.behavior;
}
function _temp8($_6) {
  return $_6.phone;
}
function _temp9($_7) {
  return $_7.synthetic;
}